
<template>
  <div class="container animated bounceInRight">
    <!--Research-->
    <div class="row">
      <div class="col-sm-11">
        <div class="card card h-90">
          <div class="card-body">
            <h1 class="centered">Pesquisas</h1>
            <hr class="divider" />
            <table class="table">
              <thead>
                <tr>
                  <th>Conteúdo</th>
                  <th>Pesquisa</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="w-40">Respostas</td>
                  <td class="w-50">
                    <select v-model="researchId" class="form-control">
                      <option
                        v-for="research in researches"
                        v-bind:key="research.id"
                        :value="research.id"
                      >
                        {{ research.research_name }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <button
                      class="btn btn-normal btn-block"
                      @click="extract('signatureUserSents')"
                    >
                      <i class="fa fa-download"></i> Respostas
                    </button>
                    <hr />
                    <button
                      class="btn btn-normal btn-block"
                      @click="extract('actionPlans')"
                    >
                      <i class="fa fa-download"></i> Planos de ação
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      researches: [],
      researchId: "",
    };
  },
  methods: {
    revertDate(datetime) {
      if (datetime) {
        return moment(datetime, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm");
      } else {
        return "";
      }
    },
    extract(extraction) {
      const self = this;
      let api = "";

      if (extraction == "signatureUserSents") {
        api =
          self.$store.state.api + "extract/research-answers/" + self.researchId;
      }
      if (extraction == "actionPlans") {
        api = self.$store.state.api + "extract/action-plans/" + self.researchId;
      }

      self.$http
        .get(api)
        .then((response) => {
          window.open(
            self.$store.getters.url +
              "extract/research-answers/" +
              response.data,
            "_blank"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getResearches() {
      const self = this;
      const api = self.$store.state.api + "researches?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.researches = response.data.data;
          self.researches.map(function (el) {
            return (el.research_name =
              el.name + " - " + self.revertDate(el.apply_start_date));
          });
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getResearches();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Extract/Extract.vue